import React from "react";
import Meaning from "./Meaning";
import "./Results.css";

export default function Results(props) {
  if (props.error) {
    return (
      <div className="Results">
        <p>{props.error}</p>
      </div>
    );
  } else if (props.results) {
    return (
      <div className="Results">
        <section>
          <h2>{props.results.word}</h2>
          <p className="phonetics">/{props.results.phonetic}/</p>
        </section>

        {props.results.meanings.slice(0, 3).map(function (meaning, index) {
          return (
            <section key={index}>
              <Meaning meaning={meaning} />
            </section>
          );
        })}
      </div>
    );
  } else {
    return null;
  }
}
